import { prepareRegionMeta } from '../../mappers';
import { fetchGetRegionMeta, TGetRegionMetaResponse } from '../../repositories/geo-temp-layer/v1/get-region-meta';
import { IApplicationContext } from '../../types/applicationContext';
import { TRegionMeta } from '../../types/regionMeta';
import { ResponseError } from '../../utils/errors';
import { lruCache } from '../../utils/lruCache';

interface IFetchRegionMetaParameters {
  locationId: number;
}

async function fetchRegionMeta(
  context: IApplicationContext,
  { locationId }: IFetchRegionMetaParameters,
): Promise<TRegionMeta> {
  const { httpApi } = context;

  const regionMetaData: TGetRegionMetaResponse = await fetchGetRegionMeta({
    httpApi,
    parameters: {
      locationId,
    },
  });

  if (regionMetaData.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchRegionMeta',
      message: regionMetaData.response.message ?? /* istanbul ignore next */ 'Failed to fetch region meta',
      details: {
        error: JSON.stringify(regionMetaData.response.errors),
      },
    });
  }

  return prepareRegionMeta(regionMetaData.response);
}

const fetchRegionMetaWithCache = lruCache(fetchRegionMeta, { key: 'regionMeta' });

export const fetchRegionMetaCached = (context: IApplicationContext, parameters: IFetchRegionMetaParameters) => {
  return fetchRegionMetaWithCache(`regionMeta.${parameters.locationId}`, context, context, parameters);
};
